import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import type { ProvisionType, UserType } from '../graphql/generated/graphql';

const ORGANIZATION_FRAGMENT = gql(`
  fragment canAuthenticateWithPassword_organization on Organization {
    id
    settings {
      authentication
    }
  }
`);

const canAuthenticateWithPassword = (
  organization:
    | DocumentType<typeof ORGANIZATION_FRAGMENT>
    | typeof window.__slab.PUBLIC_ORG,
  ssoPlatforms: string[],
  userType?: UserType | ProvisionType,
) => {
  const authenticationSetting = organization.settings.authentication;

  return (
    authenticationSetting === 'SSO_AND_PASSWORD' ||
    (authenticationSetting === 'SSO_AND_GUEST_PASSWORD' &&
      userType === 'GUEST') ||
    ssoPlatforms.length === 0
  );
};

export default canAuthenticateWithPassword;
